import { render, staticRenderFns } from "./NewProductNotification.vue?vue&type=template&id=643433f2&scoped=true"
import script from "./NewProductNotification.vue?vue&type=script&lang=ts"
export * from "./NewProductNotification.vue?vue&type=script&lang=ts"
import style0 from "./NewProductNotification.vue?vue&type=style&index=0&id=643433f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643433f2",
  null
  
)

export default component.exports